import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { CarrierSchema } from "../fulfillments/fulfillment-carriers-and-services";
import { RateProvider } from "../outbound-labels/outbound-labels";
import { WeightSchema } from "../outbound-labels/util";

export enum CarrierPickupStatus {
  SCHEDULED = "Scheduled",
  CANCELLED = "Cancelled",
}

const PickupAddressSchema_ = z.object({
  companyName: z.string().nullish(),
  contactName: z.string().nullish(),
  addressLine: z.string().nullish(),
  room: z.string().nullish(),
  floor: z.string().nullish(),
  city: z.string().nullish(),
  stateProvince: z.string().nullish(),
  postalCode: z.string().nullish(),
  countryCode: z.string().nullish(),
  phoneNumber: z.string().nullish(),
  phoneExtension: z.string().nullish(),
});

export const PickupAddressSchema: z.ZodType<PickupAddress> =
  PickupAddressSchema_;
export interface PickupAddress extends z.infer<typeof PickupAddressSchema_> {}

const TimeOfDaySchema_ = z.object({
  hour: z.number().min(0).max(23),
  minute: z.number().min(0).max(59),
});

export const TimeOfDaySchema: z.ZodType<TimeOfDay> = TimeOfDaySchema_;
export interface TimeOfDay extends z.infer<typeof TimeOfDaySchema_> {}

const carrierPickupSchema_ = z.object({
  _id: zExt.objectId(),
  team: zExt.objectId(),
  name: z.string().nullish(),
  carrier: CarrierSchema,
  provider: createEnum(RateProvider),
  pickupRequestNumber: z.string(),
  pickupDate: z.date(),
  readyTime: TimeOfDaySchema.nullish(),
  closeTime: TimeOfDaySchema.nullish(),
  pickupAddress: PickupAddressSchema.nullish(),
  packageCount: z.number().nullish(),
  totalWeight: WeightSchema.nullish(),
  specialInstructions: z.string().nullish(),
  referenceNumber: z.string().nullish(),
  status: createEnum(CarrierPickupStatus).nullish(),
  rate: z.string().nullish(),
  carrierResponse: z.record(z.string(), z.unknown()).nullish(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const CarrierPickupSchema: z.ZodType<CarrierPickup> =
  carrierPickupSchema_;
export interface CarrierPickup extends z.infer<typeof carrierPickupSchema_> {}
